import React, { useRef, useState, useEffect } from "react";
import cssClasses from "../AllAllotments.module.css";
import {
  Box,
  Card,
  Checkbox,
  ClickAwayListener,
  Grid,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Tooltip,
} from "@mui/material";
import CallIcon from "@mui/icons-material/Call";
import InfiniteScroll from "react-infinite-scroll-component";
import { useSelector } from "react-redux";
import { dismissLoader, presentLoader } from "../../../Services/loader";
import {
  getCRMTimelineData,
  getCompletedCrmAllotments,
  getFilterNames,
  getVirtualAccDetailsById,
  insertCRMLogs,
  sendWelcomePdf,
} from "../../../Services/AllAllotments";
import { errorTost, successTost } from "../../../Services/Toast";
import useAlertModal from "../../../Subcomponents/useAlertModal";
import LeadStatusChip from "../../../Subcomponents/LeadStatusChip";
import Dot from "../../Icons/Dot";
import ThreeDotsMenu from "../../../Subcomponents/ThreeDotsMenu";
import { makeStyles } from "@mui/styles";
import ReactTimeAgo from "react-time-ago";
import Button from "../../../Subcomponents/Button";
import ChangePriceModal from "../ChangePriceModal/ChangePriceModal";
import ViewAllotedCrmDetailsModal from "./ViewAllotedCrmDetailsModal/ViewAllotedCrmDetailsModal";
import _, { debounce, findIndex, orderBy } from "lodash";
import SearchBar from "../../../Subcomponents/Search";
import { supabase } from "../../../supabaseClient";
import { getProjectList, getWingList } from "../../../Services/Payments";
import DropDownButton from "../../../Subcomponents/DropDownButton";
import TreeviewCheckbox from "../../TreeviewCheckbox";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import CheckIcon from "@mui/icons-material/Check";
import DropDown from "../../../Subcomponents/DropDown";
import DateComponent from "../../../Subcomponents/DateComponent";
import ViewToggleSwitch from "../../../Subcomponents/ViewSwitch/ViewToggleSwitch";
import ServerPaginationGrid from "../../ServerPaginationGrid";
import EmptyState from "../../../Assets/Images/Common/noProjectFound.svg";
import CrmTimeLineModal from "./CRMTimeLineModal/CrmTimeLineModal";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import ViewDocumentsModal from "./ViewDocumentsModal/ViewDocumentsModal";
import EnterEmailModal from "./EnterEmailModal/EnterEmailModal";
import UpdateLeadDetails from "./CheckVirtualAccountStatus/CheckVirtualAccountStatus";
import { getLeadVirtualAccountStatus } from "../../../Services/Lead";
import PreviewAggrementConfirmationModal from "./PreviewAggrementConfirmationModal/PreviewAggrementConfirmationModal";

const useStyles = makeStyles((theme) => ({
  Grid: {
    "&.MuiGrid-item": {
      padding:
        window.innerWidth < 820
          ? "10px 1px !important"
          : "1px 0rem 2.4rem 2.4rem !important",
    },
  },
  Tabs: {
    "&.MuiTabPanel-root": {
      padding: "1rem 0rem 2rem 0rem !important",
    },
  },
}));

function CompletedCrm() {
  const classes = useStyles();

  const loggedInUser = useSelector((state) => state.Auth.user);
  const [allCrmAllotments, setAllCrmAllotments] = useState([]);
  const hasMore = useRef(true);
  const pageNumber = useRef(0);

  const [changePriceModalToggle, setChangePriceModalToggle] = useState(false);
  const [
    selectedCrmAllotmentForChangePrice,
    setSelectedCrmAllotmentForChangePrice,
  ] = useState(null);
  const [
    selectedAllotmentForViewCrmDetails,
    setSelectedAllotmentForViewCrmDetails,
  ] = useState(null);
  const [totalCount, setTotalCount] = useState(0);
  const [emailSentCount, setEmailSentCount] = useState(0);

  const searchValue = useRef("");

  //filter states

  const [btnName, setBtnName] = useState("None");
  const [filterOpen, setFilterOpen] = useState(false);
  const [projectStr, setProjectStr] = useState({ p: [], w: [], f: [] });
  const [projectSelected, setProjectSelected] = useState([]);
  const [checked, setChecked] = React.useState([]);
  const [depStr, setDepQuery] = useState("");
  const [showProjectList, setShowProjectList] = useState(false);
  const [cp, setCp] = useState([]);
  const [projects, setProjects] = useState([]);
  const [filter, setFilter] = useState("");
  const [salesRepresentative, setSalesRepresentative] = useState([]);
  const [crmUser, setCrmUser] = useState([]);
  const [searchValue1, setSearchValue1] = useState("");
  const [filterNames, setFilterNames] = useState([]);
  const [filterCheck, setFilterCheck] = useState(0);
  const [projectList, setProjectList] = useState([]);
  const [filterBy, setFilterBy] = useState("Latest First");
  const [helperText, setHelperText] = useState({
    startDate: "",
    endDate: "",
  });
  const [selectDates, setSelectDates] = useState([
    { label: "StartDate", value: "" },
    { label: "EndDate", value: "" },
  ]);
  const [selectedDates, setSelectedDate] = useState(null);
  const [mode, setMode] = useState("Card View");
  const [selectedListDropDown, setSelectedListDropDown] = useState([]);
  const [listsOrder, setListsOrder] = useState([
    "Name Ascending",
    "Name Descending",
    "Oldest First",
    "Latest First",
    "Unit No Ascending",
    "Unit No Descending",
  ]);
  const [selectedAllotments, setSelectedAllotments] = useState([]);
  const [
    selectedAllotmentForSendTestMail,
    setSelectedAllotmentForSendTestMail,
  ] = useState(null);
  const [selectedAllotmentForSendToLead, setSelectedAllotmentForSendToLead] =
    useState(null);
  const { showError, AlertModal } = useAlertModal();
  const [selectedAllotmentDataToApprove, setSelectedAllotmentDataToApprove] =
    useState([]);
  const [selectBtnName, setSelectBtnName] = useState("Select All");
  const [leadDisplayId, setLeadDisplayId] = useState("")
  const [virtualAccountStatusModal, setVirtualAccountStatusModal] = useState(false)
  const [allotmentData, setAllotmentData] = useState([])
  const isInitialRender = useRef(true);
  const [previewAggrementData, SetPreviewAggrementData] = useState([]);
  const [previewAggrementModalToggle, SetPreviewAggrementModalToggle] = useState(false);
  const [viewCostSheet, setViewCostSheet] = useState(false);

  const [filterObj, setFilterObj] = useState([
    {
      id: 0,
      label: "None",
      value: "None",
    },
    {
      id: 1,
      label: "Date",
      value: "Date",
    },
    {
      id: 2,
      label: "CP",
      value: "CP",
      selected: false,
    },
    {
      id: 3,
      label: "SM",
      value: "Users",
      selected: false,
    },
    {
      id: 4,
      label: "CRM",
      value: "CrmUsers",
      selected: false,
    },
    {
      id: 5,
      label: "Projects",
      value: "Projects",
      selected: false,
    },
    {
      id: 6,
      label: "SDR",
      value: "SDR",
      selected: false,
    },
    {
      id: 7,
      label: "Email",
      value: "Email",
      selected: false,
    },
    {
      id: 8,
      label: "OCR",
      value: "OCR",
      selected: false,
    },
    {
      id: 9,
      label: "AV",
      value: "AV",
      selected: false,
    },
    {
      id: 10,
      label: "Agreement KYC",
      value: "Agreement KYC",
      selected: false,
    },
    {
      id: 11,
      label: "Emandate",
      value: "Emandate",
      selected: false,
    },
  ]);
  const [crmTimeLineModalToggle, setcrmTimeLineModalToggle] = useState(false);

  useEffect(() => {
    if (filter == "CP") {
      setFilterNames(cp);
    } else if (filter == "Projects") {
      setFilterNames(projects);
    } else if (filter == "Users") {
      setFilterNames(salesRepresentative);
    } else if (filter == "CrmUsers") {
      setFilterNames(crmUser);
    } else if (filter == "Date") {
      setFilterNames([]);
    } else if (filter == "Status") {
      setFilterNames([
        { filter: "Status", name: "Payment Complete", id: "Payment Complete" },
        {
          filter: "Status",
          name: "Cancellation Requested",
          id: "Cancellation Requested",
        },

        {
          filter: "Status",
          name: "Cancellation Pending",
          id: "Cancellation Pending",
        },
        {
          filter: "Status",
          name: "Cancellation Rejected",
          id: "Cancellation Rejected",
        },
        {
          filter: "Status",
          name: "Cancellation Done",
          id: "Cancellation Done",
        },
        {
          filter: "Status",
          name: "Cancellation Not Done",
          id: "Cancellation Not Done",
        },
        { filter: "Status", name: "Cancelled", id: "Cancelled" },
      ]);
    } else if (filter == "SDR") {
      setFilterNames([
        { filter: "SDR", name: "SDR Pending", id: "SDR Pending" },
        { filter: "SDR", name: "SDR Complete", id: "SDR Complete" },
      ]);
    } else if (filter == "OCR") {
      setFilterNames([
        { filter: "OCR", name: "Less than 10%", id: "Less than 10%" },
        { filter: "OCR", name: "Equals to 10%", id: "Equals to 10%" },
        { filter: "OCR", name: "Greater than 10%", id: "Greater than 10%" },
      ]);
    } else if (filter == "Email") {
      setFilterNames([
        { filter: "Email", name: "Email Sent", id: "Email Sent" },
        { filter: "Email", name: "Email Not Sent", id: "Email Not Sent" },
      ]);
    } else if (filter == "AV") {
      setFilterNames([
        { filter: "AV", name: "AV Changed", id: "AV Changed" },
        { filter: "AV", name: "AV Not Changed", id: "AV Not Changed" },
      ]);
    } else if (filter === "Agreement KYC") {
      setFilterNames([
        { filter: "Agreement KYC", name: "Agreement KYC Done", id: "Agreement KYC Done" },
        { filter: "Agreement KYC", name: "Agreement KYC Pending", id: "Agreement KYC Pending" },
      ]);
    } else if (filter == "Emandate") {
      setFilterNames([
        { filter: "Emandate", name: "Pending", id: "Pending" },
        { filter: "Emandate", name: "Partial", id: "Partial" },
        { filter: "Emandate", name: "Completed", id: "Completed" },
      ]);
    }
  }, [filter, filterObj]);

  useEffect(() => {
    if (isInitialRender.current) {
      isInitialRender.current = false;
    } else {
      getCrmAllotmentsFromServer(false);
    }
  }, [filterBy]);


  useEffect(() => {
    if (filter === "CP") {
      setFilterNames(
        cp.filter((f) =>
          searchValue1
            ? f?.name?.toLowerCase()?.includes(searchValue1?.toLowerCase())
            : true
        )
      );
    }

    if (filter === "Users") {
      setFilterNames(
        salesRepresentative.filter((f) =>
          searchValue1
            ? f?.name?.toLowerCase()?.includes(searchValue1?.toLowerCase())
            : true
        )
      );
    }

    if (filter === "CrmUsers") {
      setFilterNames(
        crmUser.filter((f) =>
          searchValue1
            ? f?.name?.toLowerCase()?.includes(searchValue1?.toLowerCase())
            : true
        )
      );
    }

    if (filter === "Projects") {
      if (searchValue1 !== "") {
        setProjectList(
          projectList.filter((f) =>
            searchValue1
              ? f?.label?.toLowerCase()?.includes(searchValue1?.toLowerCase())
              : true
          )
        );
      } else {
        const fetchEvents = async () => {
          const data = await getProjectList();
          setProjectList(data);
        };
        fetchEvents();
      }
    }
  }, [searchValue1]);

  useEffect(() => {
    let all_filters = [];

    let all_cpId = [];
    let all_projectId = [];
    let all_salesRepresentativeId = [];
    let all_status = [];
    let all_crmUsers = [];
    let all_sdr = [];
    let all_email = [];
    let all_ocr = [];
    let all_av = [];;
    let all_agreement_kyc = [];
    let jsonParse;
  let all_emandate_status = [];

    checked.map((item) => {
      jsonParse = JSON.parse(item);
      if (jsonParse.filter == "CP") {
        all_cpId.push(jsonParse.value);
      } else if (jsonParse.filter == "Projects") {
        all_projectId.push(jsonParse.value);
      } else if (jsonParse.filter == "Users") {
        all_salesRepresentativeId.push(jsonParse.value);
      } else if (jsonParse.filter == "CrmUsers") {
        all_crmUsers.push(jsonParse.value);
      } else if (jsonParse.filter == "Status") {
        all_status.push(jsonParse.value);
      } else if (jsonParse.filter == "SDR") {
        all_sdr.push(jsonParse.value);
      } else if (jsonParse.filter == "OCR") {
        all_ocr.push(jsonParse.value);
      } else if (jsonParse.filter == "Email") {
        all_email.push(jsonParse.value);
      } else if (jsonParse.filter == "AV") {
        all_av.push(jsonParse.value);
      } else if (jsonParse.filter == "Agreement KYC") {
        all_agreement_kyc.push(jsonParse.value)
      } else if (jsonParse.filter == "Emandate"){
        all_emandate_status.push(jsonParse.value)
      }
    });

    if (all_cpId.length !== 0) {
      if (all_filters.indexOf("CP") == -1) {
        all_filters.push("CP");
      }
    }

    if (all_status.length !== 0) {
      if (all_filters.indexOf("Status") == -1) {
        all_filters.push("Status");
      }
    }

    if (all_sdr.length !== 0) {
      if (all_filters.indexOf("SDR") == -1) {
        all_filters.push("SDR");
      }
    }

    if (all_ocr.length !== 0) {
      if (all_filters.indexOf("OCR") == -1) {
        all_filters.push("OCR");
      }
    }

    if (all_email.length !== 0) {
      if (all_filters.indexOf("Email") == -1) {
        all_filters.push("Email");
      }
    }

    if (all_av.length !== 0) {
      if (all_filters.indexOf("AV") == -1) {
        all_filters.push("AV");
      }
    }

    if (all_agreement_kyc.length !== 0) {
      if (all_filters.indexOf("Agreement KYC") == -1) {
        all_filters.push("Agreement KYC");
      }
    }

    if (
      all_projectId[0]?.[0]?.["p"]?.length > 0 ||
      all_projectId[0]?.[0]?.["w"]?.length > 0 ||
      all_projectId[0]?.[0]?.["f"]?.length > 0
    ) {
      if (all_filters.indexOf("Projects") == -1) {
        all_filters.push("Projects");
      }
    }

    if (selectDates[0]?.value !== "" && selectDates[1]?.value !== "") {
      if (all_filters.indexOf("Date") == -1) {
        all_filters.push("Date");
      }
    }

    if (all_salesRepresentativeId.length !== 0) {
      if (all_filters.indexOf("SM") == -1) {
        all_filters.push("SM");
      }
    }

    if (all_crmUsers.length !== 0) {
      if (all_filters.indexOf("CRM") == -1) {
        all_filters.push("CRM");
      }
    }
    // if (projectSelected.length !== 0) {
    //   all_filters.push("Project");
    // }
    if (all_emandate_status.length !== 0) {
      if (all_filters.indexOf("Emandate") == -1) {
        all_filters.push("Emandate");
      }
    }
    
    if (all_filters.length == 0) {
      setBtnName("None");
    } else {
      setBtnName(all_filters.join(","));
    }
  }, [checked, selectDates]);

  useEffect(() => {
    if (filter === "None") {
      setSelectDates([
        { label: "StartDate", value: "" },
        { label: "EndDate", value: "" },
      ]);
    }
  }, [filter]);

  useEffect(() => {
    const fetchEvents = async () => {
      const data = await getProjectList();
      setProjectList(data);
    };
    fetchEvents();
  }, []);

  //end filter states
  useEffect(() => {
    // if (loggedInUser?.isCrmUser && loggedInUser?.id) {
    if (loggedInUser?.id && allCrmAllotments?.length === 0) {
      getCrmAllotmentsFromServer(false);
    }
  }, [loggedInUser]);

  async function getFilterAllotmentForDatagrid(nextRange = { from: 0, to: 9 }) {
    let items = await getFilterAllotmentPagination(false, true, nextRange);
    return items;
  }

  async function getFilterAllotmentPagination(
    merge = false,
    isShowSpinner = true,
    nextRange
  ) {
    //setAllAllotments([])
    try {
      // ! if loggedInUser is superadmin or change plan approver; show all entries
      // const _loggedInUserId =
      //   !loggedInUser?.parentId ||
      //     loggedInUser?.roleId?.accessibleTabs?.["All Allotments"]?.CRM?.[
      //       "Changed plan"
      //     ]?.Approve?.isAccessible
      //     ? null
      //     : loggedInUser?.id;

      const _loggedInUserId = !loggedInUser?.parentId
        ? null
        : loggedInUser?.roleId?.accessibleTabs?.["All Allotments"]?.CRM?.[
          "Show CRM"
        ]?.show === "All"
          ? null
          : loggedInUser?.id;
      const getCompletedCrmAllotmentsResponse = await getCompletedCrmAllotments(
        _loggedInUserId,
        pageNumber?.current,
        searchValue.current,
        filterBy,
        checked,
        selectDates,
        nextRange,
        true
      );

      if (getCompletedCrmAllotmentsResponse.data) {
        const emailSentData = await supabase
          .from("CRM")
          .select("*", { count: "exact" })
          .eq("isEmailSent", true)
          .eq("isApproved", true);
        setTotalCount(emailSentData.count);
        setTotalCount(getCompletedCrmAllotmentsResponse.count);

        if (getCompletedCrmAllotmentsResponse.data) {
          // setSelectBtnName("Select All");
          // setSelectedAllotments([]);
          selectBtnName === "Select All" ? setSelectBtnName("Select All") : setSelectBtnName("Remove All");
          selectBtnName === "Remove All" ? setSelectedAllotments(getCompletedCrmAllotmentsResponse?.data) : setSelectedAllotments([]);

          getCompletedCrmAllotmentsResponse.data.forEach((crmData) => {
            crmData.menuOptions = [
              "Send Test Mail",
              "Send Email To Customer",
              "View CRM Details",
              "Timeline And Notes",
              "Check Virtual Account Status"
            ];
            if (crmData?.is_agreement_form_filled) {
              crmData.menuOptions.push("Preview Agreement Confirmation Form")
            }
            if (loggedInUser?.roleId?.accessibleTabs?.["All Allotments"]?.CRM?.Completed?.["View Cost Sheet"]?.isAccessible) {
              crmData.menuOptions.push("View Cost Sheet")
            }
            crmData.menuOptions.sort();
          });
          setTotalCount(getCompletedCrmAllotmentsResponse.count);

          if (!merge && getCompletedCrmAllotmentsResponse.data.length) {
            let res = getCompletedCrmAllotmentsResponse.data;

            if (!merge) {
              setAllCrmAllotments((pre) => [...res]);
              isShowSpinner && dismissLoader();
            } else {
              setAllCrmAllotments((pre) => [...pre, ...res]);
              isShowSpinner && dismissLoader();
            }
          }

          setFilterOpen(false);
          return getCompletedCrmAllotmentsResponse.data;
        }
      }
    } catch (err) {
      if (err?.message) {
        errorTost(err?.message);
      } else {
        errorTost("Something went wrong! Try again");
      }
    }
  }
  useEffect(() => {
    let updateUnitListener = supabase
      // .from(`CRM:requestPendingWith=eq.${loggedInUser?.id}`)
      .from(
        `CRM${!loggedInUser?.parentId
          ? ""
          : loggedInUser?.roleId?.accessibleTabs?.["All Allotments"]?.CRM?.[
            "Show CRM"
          ]?.show === "All"
            ? ""
            : `:requestPendingWith=eq.${loggedInUser?.id}`
        }`
      )
      .on("UPDATE", (handleRecordUpdated) => {
        if (
          searchValue.current === "" &&
          filterBy === "Latest First" &&
          checked.length === 0
        ) {
          searchValue.current = "";
          pageNumber.current = 0;
          hasMore.current = true;
          getCrmAllotmentsFromServer(false);
        }
      })
      .subscribe((status) => {
        console.log("status: ", status);
      });
    return () => {
      if (updateUnitListener) {
        supabase.removeSubscription(updateUnitListener);
        updateUnitListener = null;
      }
    };
  }, []);

  useEffect(() => {
    let updateUnitListener = supabase
      .from(`AllotmentPayment`)
      .on("UPDATE", (handleRecordUpdated) => {
        if (
          searchValue.current === "" &&
          filterBy === "Latest First" &&
          checked.length === 0
        ) {
          searchValue.current = "";
          pageNumber.current = 0;
          hasMore.current = true;
          getCrmAllotmentsFromServer(false);
        }
      })
      .subscribe((status) => {
        console.log("status: ", status);
      });
    return () => {
      if (updateUnitListener) {
        supabase.removeSubscription(updateUnitListener);
        updateUnitListener = null;
      }
    };
  }, []);

  async function getCrmAllotmentsFromServer(merge, isCheckedClear = false) {
    if (!merge) {
      pageNumber.current = 0;
      hasMore.current = true;
      // setChecked([]);
    }
    mode === "Table View" && setAllCrmAllotments([]);
    const selectedDate = { ...selectDates };
    try {
      presentLoader();
      // ! if loggedInUser is superadmin or change plan approver; show all entries
      // const _loggedInUserId =
      //   !loggedInUser?.parentId ||
      //     loggedInUser?.roleId?.accessibleTabs?.["All Allotments"]?.CRM?.[
      //       "Changed plan"
      //     ]?.Approve?.isAccessible
      //     ? null
      //     : loggedInUser?.id;
      const _loggedInUserId = !loggedInUser?.parentId
        ? null
        : loggedInUser?.roleId?.accessibleTabs?.["All Allotments"]?.CRM?.[
          "Show CRM"
        ]?.show === "All"
          ? null
          : loggedInUser?.id;
      // const _loggedInUserId = !loggedInUser?.parentId ? null : loggedInUser?.id;
      await getCompletedCrmAllotments(
        _loggedInUserId,
        pageNumber.current,
        searchValue.current,
        filterBy,
        checked,
        isCheckedClear ? undefined : selectedDate,
        null,
        null,
        false
      )
        .then((getCompletedCrmAllotmentsResponse) => {
          setTotalCount(getCompletedCrmAllotmentsResponse.count);
          if (getCompletedCrmAllotmentsResponse.data) {
            getCompletedCrmAllotmentsResponse.data.forEach((crmData) => {
              crmData.menuOptions = [
                "Send Test Mail",
                "Send Email To Customer",
                "View CRM Details",
                "Timeline And Notes",
                "Check Virtual Account Status"
              ];
              if (crmData?.is_agreement_form_filled) {
                crmData.menuOptions.push("Preview Agreement Confirmation Form")
              }
              if (loggedInUser?.roleId?.accessibleTabs?.["All Allotments"]?.CRM?.Completed?.["View Cost Sheet"]?.isAccessible) {
                crmData.menuOptions.push("View Cost Sheet")
              }
              crmData.menuOptions.sort();
            });
            if (merge) {
              setAllCrmAllotments((pre) => [
                ...pre,
                ...getCompletedCrmAllotmentsResponse.data,
              ]);
            } else {
              setAllCrmAllotments([...getCompletedCrmAllotmentsResponse.data]);
            }
            if (getCompletedCrmAllotmentsResponse.data.length < 10) {
              hasMore.current = false;
            }
            dismissLoader();
          } else {
            throw getCompletedCrmAllotmentsResponse;
          }
        })
        .catch((err) => {
          console.log(err);
          throw err;
        });

      await getCompletedCrmAllotments(
        _loggedInUserId,
        pageNumber.current,
        searchValue.current,
        filterBy,
        merge ? checked : [],
        isCheckedClear ? undefined : selectedDate,
        null,
        null,
        true
      )
        .then((emailSentData) => {
          setEmailSentCount(emailSentData.data.length);
        })
        .catch((err) => {
          console.log(err);
          throw err;
        });
    } catch (error) {
      if (error?.status === 416) {
        hasMore.current = false;
      } else if (error?.error?.message) {
        errorTost(error?.error?.message);
      } else {
        errorTost("Something went wrong! Try again");
      }
      dismissLoader();
    }
  }

  async function sendTestMailHandler(email_id) {
    if (!email_id) {
      errorTost("Email");
      return;
    }
    try {
      presentLoader();
      const sendWelcomePdfResponse = await sendWelcomePdf(
        selectedAllotmentForSendTestMail?.id,
        email_id,
        false
      );
      if (sendWelcomePdfResponse.data?.success) {
        successTost("Email sent successfully.");
      } else {
        throw sendWelcomePdfResponse.data;
      }
      dismissLoader();
      setSelectedAllotmentForSendTestMail(null);
    } catch (error) {
      const msg = error?.error?.message || error?.message || "Could not send email.";
      showError(msg);
      dismissLoader();
      setSelectedAllotmentForSendTestMail(null);
    }
  }

  async function sendMailToLeadHandler(val = null) {
    try {
      presentLoader();
      const sendWelcomePdfResponse = await sendWelcomePdf(
        mode === "Table View" ? val?.id : selectedAllotmentForSendToLead?.id,
        null,
        false
      );
      if (sendWelcomePdfResponse.data?.success) {
        successTost("Email sent successfully to lead.");
        if (!selectedAllotmentForSendToLead?.isemailsent) {
          const crmObj = {
            message: `Welcome email is successfully sent to the ${selectedAllotmentForSendToLead?.lead_name} for allotment unit ${selectedAllotmentForSendToLead?.unit_no} of project ${selectedAllotmentForSendToLead?.project_name}.`,
            allotmentPaymentId: selectedAllotmentForSendToLead?.allotment_payment_id,
            crmStatus: "Welcome email sent",
          };
          insertCRMLogs(crmObj)
            .then((res) => {
              console.log("Logs saved", res);
            })
            .catch((err) => {
              console.log(err);
            });
        }
      } else {
        throw sendWelcomePdfResponse.data;
      }
      dismissLoader();
      setSelectedAllotments([]);
      setSelectedAllotmentForSendToLead(null);
    } catch (error) {
      showError(error?.error?.message || "Something went wrong! Try again");
      dismissLoader();
      setSelectedAllotments([]);
      setSelectedAllotmentForSendToLead(null);
    }
  }

  function getAgreementDateInFormat(time) {
    const dateInFormat =
      new Date(time).toDateString() +
      " " +
      new Date(time).toLocaleTimeString([], {
        hour: "2-digit",
        minute: "2-digit",
      });
    // console.log(dateInFormat);
    if (dateInFormat !== "Invalid Date Invalid Date") return dateInFormat;
  }

  const debouncedFetchSearchData = debounce((e) => {
    searchValue.current = e.target.value;
    pageNumber.current = 0;
    hasMore.current = true;
    getCrmAllotmentsFromServer(false);
  }, 800);

  //filter function

  const handleToggle = (value, filter) => () => {
    const currentIndex = checked.indexOf(
      JSON.stringify({ value: value, filter: filter })
    );
    const newChecked = [...checked];

    if (currentIndex === -1) {
      newChecked.push(JSON.stringify({ value: value, filter: filter }));
    } else {
      newChecked.splice(currentIndex, 1);
    }

    setChecked(newChecked);
  };

  const handleFilterApply = async () => {
    setAllCrmAllotments([]);
    pageNumber.current = 0;
    hasMore.current = true;
    if (checked) {
      presentLoader();
      getCrmAllotmentsFromServer(true);

      setFilterOpen(false);
      dismissLoader();
    }
    setDepQuery(
      filter +
      JSON.stringify(checked) +
      JSON.stringify(projectStr) +
      Math.random(0, 1)
    );
  };

  const handleFilterClose = (isClear = false) => {
    if (filterOpen) {
      isClear && setProjectSelected([]);
      isClear && setProjectStr({ p: [], w: [], f: [] });
      isClear && setChecked([]);
      isClear &&
        setSelectDates([
          { label: "StartDate", value: "" },
          { label: "EndDate", value: "" },
        ]);
      isClear && getSubfilters("None", 0);
      setFilterOpen(false);
      isClear && setDepQuery(depStr + 1);
      isClear && getCrmAllotmentsFromServer(false, true);
    } else {
      setFilterOpen(true);
    }

    // setChecked([]);
  };

  async function getSubfilters(value, filterId) {
    let CP_Items = [];
    let Project_Items = [];

    if (value !== "Projects") {
      setShowProjectList(false);
    }
    if (value == "CP") {
      if (!cp[0]) {
        presentLoader();
        const { data } = await getFilterNames(value);
        dismissLoader();
        data.map((item) => {
          CP_Items.push({
            id: item.cpId,
            name: item.billingName,
            filter: value,
          });
        });
        const sortedCp = orderBy(
          CP_Items,
          [(cp) => cp.name.toLowerCase()],
          ["asc"]
        );
        setCp(sortedCp);
        setFilterNames(sortedCp);
      }
      setFilter(value);
    } else if (value == "Projects") {
      setShowProjectList(true);
      setFilter(value);
      if (!projectList[0]) {
        const data = await getProjectList();
        setProjectList(data);
      }
      setFilter(value);
    } else if (value == "Projects") {
      setShowProjectList(true);
      setFilter(value);
      if (!projects[0]) {
        presentLoader();
        const { data } = await getFilterNames(value);
        dismissLoader();
        data.map((item) => {
          Project_Items.push({
            id: item.projectId,
            name: item.projectName,
            filter: value,
          });
        });
        const sortedProjects = orderBy(
          Project_Items,
          [(project) => project.name.toLowerCase()],
          ["asc"]
        );
        setProjects(sortedProjects);
      }
      setFilter(value);
    } else if (value == "Users") {
      if (!salesRepresentative[0]) {
        presentLoader();
        const { data } = await getFilterNames(value);
        dismissLoader();
        data.map((item) => {
          (item?.isCrmUser === null || item?.isCrmUser === false) &&
            Project_Items.push({
              id: item.userId,
              name: item.name,
              filter: value,
            });
        });

        const sortedSales = orderBy(
          Project_Items,
          [(user) => user.name.toLowerCase()],
          ["asc"]
        );
        setSalesRepresentative(sortedSales);
        setFilterNames(sortedSales);
      }
      setFilter(value);
    } else if (value == "CrmUsers") {
      if (!crmUser[0]) {
        presentLoader();
        const { data } = await getFilterNames("Users");
        dismissLoader();
        data.map((item) => {
          item?.isCrmUser === true &&
            Project_Items.push({
              id: item.userId,
              name: item.name,
              filter: value,
            });
        });

        const sortedSales = orderBy(
          Project_Items,
          [(user) => user.name.toLowerCase()],
          ["asc"]
        );
        setCrmUser(sortedSales);
        setFilterNames(sortedSales);
      }
      setFilter(value);
    } else if (value == "priceRange") {
      setFilter(value);
    } else if (value == "Date") {
      setFilter(value);
    } else if (value == "Status") {
      setFilter(value);
      setFilterNames([
        { filter: "Status", name: "Payment Complete", id: "Payment Complete" },
        {
          filter: "Status",
          name: "Cancellation Requested",
          id: "Cancellation Requested",
        },

        {
          filter: "Status",
          name: "Cancellation Pending",
          id: "Cancellation Pending",
        },
        {
          filter: "Status",
          name: "Cancellation Rejected",
          id: "Cancellation Rejected",
        },
        {
          filter: "Status",
          name: "Cancellation Done",
          id: "Cancellation Done",
        },
        {
          filter: "Status",
          name: "Cancellation Not Done",
          id: "Cancellation Not Done",
        },
        { filter: "Status", name: "Cancelled", id: "Cancelled" },
      ]);
    } else if (value == "SDR") {
      setFilter(value);
      setFilterNames([
        { filter: "SDR", name: "SDR Pending", id: "SDR Pending" },
        { filter: "SDR", name: "SDR Complete", id: "SDR Complete" },
      ]);
    } else if (value == "OCR") {
      setFilter(value);
      setFilterNames([
        { filter: "OCR", name: "Less than 10%", id: "Less than 10%" },
        { filter: "OCR", name: "Equals to 10%", id: "Equals to 10%" },
        { filter: "OCR", name: "Greater than 10%", id: "Greater than 10%" },
      ]);
    } else if (value == "Email") {
      setFilter(value);
      setFilterNames([
        { filter: "Email", name: "Email Sent", id: "Email Sent" },
        { filter: "Email", name: "Email Not Sent", id: "Email Not Sent" },
      ]);
    } else if (value === "AV") {
      setFilter(value);
      setFilterNames([
        { filter: "AV", name: "AV Changed", id: "AV Changed" },
        { filter: "AV", name: "AV Not Changed", id: "AV Not Changed" },
      ]);
    } else if (value === "Agreement KYC") {
      setFilter(value);
      setFilterNames([
        { filter: "Agreement KYC", name: "Agreement KYC Done", id: "Agreement KYC Done" },
        { filter: "Agreement KYC", name: "Agreement KYC Pending", id: "Agreement KYC Pending" },
      ]);
    } else if (value == "Emandate") {
      setFilter(value);
      setFilterNames([
        { filter: "Emandate", name: "Pending", id: "Pending" },
        { filter: "Emandate", name: "Partial", id: "Partial" },
        { filter: "Emandate", name: "Completed", id: "Completed" },
      ]);
    } else {
      setFilterNames([]);
      setCp([]);
      setSalesRepresentative([]);
      setCrmUser([]);
      setChecked([]);
      setProjects([]);
      setProjectList([]);

      setFilter("None");
    }

    setFilterCheck(filterId);
  }

  const debouncedFetchSearchData1 = debounce((e) => {
    setSearchValue1(e.target.value);
  }, 500);
  //end filter function

  const filterAllotmentBySort = (e) => {
    setFilterBy(e);
    pageNumber.current = 0;
    hasMore.current = true;
  };

  const handleFetchChild = (id) => {
    const fetchEvents = async () => {
      const data = await getWingList(id);
      const finalPayload = [...projectList];
      const index = finalPayload.findIndex((i) => i.id === id);
      finalPayload.splice(index, 1, data[0]);
      setProjectList(finalPayload);
    };
    fetchEvents();
  };
  // const getCRMTimeLineNotesModalData = (allotment) => {
  //   presentLoader();
  //   getCRMTimelineData(allotment?.allotment_payment_id).then((val) => {
  //     dismissLoader();

  //     setcrmTimeLineModalToggle(true);

  //     const CRMTimelineData = {
  //       ...val,
  //       allotment,
  //     };
  //     setCrmTimeLineModalData(CRMTimelineData);
  //     // console.log("full data", crmTimeLineModalData);
  //   });
  // };

  const closeCrmModal = () => {
    setcrmTimeLineModalToggle(false);
  };

  const filterContent = () => {
    return (
      <div
        className={cssClasses.filterWrapper}
        style={{ flexDirection: "row", alignItems: "baseline", gap: "10px" }}
      >
        <div className={cssClasses.label} style={{ minWidth: "55px" }}>
          <p style={{ margin: "4px 0", fontSize: "1.6rem" }}>Filter by</p>
        </div>
        <ClickAwayListener
          onClickAway={() => {
            setFilterOpen(false);
          }}
        >
          <div
            className={cssClasses.dropdownWrapper}
            style={{ minWidth: "120px" }}
          >
            <DropDownButton
              style={{
                color: "#323232",
                backgroundColor: "#fff",
                fontSize: "1.4rem",
                lineHeight: "2rem",
                fontFamily: "Inter-Medium !important",
                height: "34px",
              }}
              btnTextStyle={{ width: "130px" }}
              btnName={btnName}
              // outline={true}
              clicked={() => handleFilterClose(false)}
              btnIcon={
                <ExpandMoreIcon style={{ width: "15px", height: "15px" }} />
              }
              iconPosition={"right"}
            />

            <div
              className={cssClasses.filterModalWrapper}
              style={{ display: filterOpen ? "block" : "none" }}
            >
              <div className={cssClasses.filterModalChild}>
                <div style={{ width: "50%" }}>
                  <List
                    sx={{
                      width: "100%",
                      maxWidth: 360,
                      bgcolor: "background.paper",
                    }}
                    component="nav"
                    aria-labelledby="nested-list-subheader"
                  >
                    {filterObj.map((item) => {
                      return (
                        <ListItem
                          style={{ padding: "0" }}
                          onClick={() => {
                            getSubfilters(item.value, item.id);
                          }}
                        >
                          <ListItemButton>
                            <ListItemText primary={item.label} />

                            {filterCheck == item.id ? (
                              <ListItemIcon style={{ minWidth: "auto" }}>
                                <CheckIcon fontSize="large" color="primary" />
                              </ListItemIcon>
                            ) : (
                              ""
                            )}
                          </ListItemButton>
                        </ListItem>
                      );
                    })}
                  </List>
                </div>

                <div
                  style={{
                    padding: "0 6px",
                    width: "75%",
                    backgroundColor: "#F9FAFB",
                    borderRadius: "8px",
                    height: "390px",
                    overflowY: "auto",
                    overflowX: "hidden",
                  }}
                >
                  {showProjectList ? (
                    <Box mt={1}>
                      {filter === "Projects" && (
                        <div style={{ margin: "5px" }}>
                          <SearchBar
                            placeholder={"Search "}
                            search={debouncedFetchSearchData1}
                            id={"tagPendingCrmAllotmentLeadName"}
                          />
                        </div>
                      )}
                      {projectList?.length === 0 ? (
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            top: "70%",
                            height: "325px",
                            fontSize: "1.5rem",
                            alignItems: "center",
                          }}
                        >
                          No Data Available
                        </div>
                      ) : (
                        <TreeviewCheckbox
                          data={projectList}
                          isChildFetch
                          handleFetchChildren={(t) => {
                            handleFetchChild(t);
                          }}
                          selectedCheckboxes={projectSelected}
                          onSelectCheckbox={setProjectSelected}
                          onChange={(str) => {
                            console.log(str);
                            setProjectStr(str);
                            setChecked((prev) => [
                              ...prev.filter((item) => {
                                prev = JSON.parse(item);
                                return prev.filter !== "Projects";
                              }),
                              JSON.stringify({
                                value: [str],
                                filter: "Projects",
                              }),
                            ]);
                          }}
                        />
                      )}
                    </Box>
                  ) : (
                    <List
                      sx={{
                        width: "100%",
                        maxWidth: 360,
                        bgcolor: "background.#F9FAFB",
                        overflowY: "auto",
                        overflowX: "hidden",
                        // height: "250px",
                      }}
                    >
                      {filter === "Date" ? (
                        <div>
                          <div className={cssClasses.dateDivider}>
                            <div className={cssClasses.label}>Start Date</div>
                            <DateComponent
                              value={selectDates[0].value}
                              minDate={"1 Jan"}
                              maxDate={new Date()}
                              onChangeDate={(value) => {
                                setSelectedDate("notNull");
                                setSelectDates((pre) => {
                                  pre[0].value = value;
                                  return { ...pre };
                                });
                                setHelperText((pre) => {
                                  pre.endDate = "";
                                  return { ...pre };
                                });
                              }}
                              helperText={helperText.startDate}
                            ></DateComponent>
                          </div>
                          <div>
                            <div className={cssClasses.label}>End Date</div>
                            <DateComponent
                              value={selectDates[1].value}
                              isClassName
                              minDate={"1 Jan"}
                              onChangeDate={(value) => {
                                setSelectedDate("notNull");
                                if (selectDates[0].value === "") {
                                  setHelperText((pre) => {
                                    pre.endDate =
                                      "Please select start date first";
                                    return { ...pre };
                                  });
                                } else {
                                  if (selectDates[0].value > value) {
                                    setHelperText((pre) => {
                                      pre.endDate =
                                        "Select End Date Greater than start Date";
                                      return { ...pre };
                                    });
                                  } else {
                                    setSelectDates((pre) => {
                                      pre[1].value = value;
                                      return { ...pre };
                                    });
                                    setHelperText((pre) => {
                                      pre.endDate = "";
                                      return { ...pre };
                                    });
                                    let indexOfMainList = findIndex(
                                      filterObj,
                                      ({ label }) => label === "Date"
                                    );
                                    setFilterObj((pre) => {
                                      pre[indexOfMainList].select = true;
                                      return [...pre];
                                    });
                                    if (
                                      selectedListDropDown.find(
                                        (value) => value === "Date"
                                      ) === undefined
                                    ) {
                                      selectedListDropDown.push("Date");
                                    }
                                  }
                                }
                              }}
                              helperText={helperText.endDate}
                            ></DateComponent>
                          </div>
                        </div>
                      ) : (
                        ["Users", "CrmUsers", "CP", "Projects"].map((fil) => {
                          return (
                            <div style={{ margin: "5px" }}>
                              {fil === filter && (
                                <SearchBar
                                  placeholder={filter}
                                  search={debouncedFetchSearchData1}
                                  id={"tagPendingCrmAllotmentLeadName"}
                                />
                              )}
                            </div>
                          );
                        })
                      )}
                      {filterNames?.length === 0 &&
                        ["Users", "CrmUsers", "CP", "Projects"].includes(
                          filter
                        ) ? (
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            top: "70%",
                            height: "325px",
                            fontSize: "1.5rem",
                            alignItems: "center",
                          }}
                        >
                          No Data Available
                        </div>
                      ) : (
                        filterNames.map((item) => {
                          const labelId = `checkbox-list-label-${item.id}`;

                          return (
                            <ListItem key={item.id} disablePadding>
                              <ListItemButton
                                role={undefined}
                                onClick={handleToggle(item.name, item.filter)}
                                dense
                              >
                                <ListItemIcon style={{ minWidth: "auto" }}>
                                  <Checkbox
                                    edge="start"
                                    checked={
                                      checked.indexOf(
                                        JSON.stringify({
                                          value: item.name,
                                          filter: item.filter,
                                        })
                                      ) !== -1
                                    }
                                    tabIndex={-1}
                                    disableRipple
                                    inputProps={{
                                      "aria-labelledby": labelId,
                                    }}
                                  />
                                </ListItemIcon>
                                <ListItemText
                                  id={labelId}
                                  primary={item.name}
                                />
                              </ListItemButton>
                            </ListItem>
                          );
                        })
                      )}
                    </List>
                  )}
                </div>
              </div>

              <div
                style={{
                  display: "flex",
                  width: "100%",
                  backgroundColor: "#F9FAFB",
                  padding: "12px",
                  borderBottomLeftRadius: "8px",
                  borderBottomRightRadius: "8px",
                  borderTop: "1px solid #EAECF0",
                  justifyContent: "end",
                  position: "relative",
                }}
              >
                <div
                  style={{
                    width: "100px",
                    float: "right",
                    marginRight: "12px",
                    backgroundColor: "#F9FAFB",
                  }}
                >
                  <Button
                    style={{
                      width: "100px",
                      color: "#323232",
                      backgroundColor: "#fff",
                      fontSize: "1.4rem",
                      lineHeight: "2rem",
                      fontFamily: "Inter-Medium !important",

                      // marginLeft: "-12px"
                    }}
                    btnName={"Clear"}
                    // outline={true}
                    clicked={() => handleFilterClose(true)}
                    // btnIcon={<AddIcon style={{ width: "15px", height: "15px" }} />}
                    iconPosition={"left"}
                  />
                </div>
                <div
                  style={{
                    width: "100px",
                  }}
                >
                  <Button
                    style={{
                      color: "#fff",
                      backgroundColor: "#1570EF",
                      fontSize: "1.4rem",
                      lineHeight: "2rem",
                      fontFamily: "Inter-Medium !important",

                      // marginLeft: "-12px"
                    }}
                    btnName={"Apply"}
                    // outline={true}
                    disable={
                      helperText?.startDate !== "" || helperText?.endDate !== ""
                    }
                    clicked={handleFilterApply}
                    // btnIcon={<AddIcon style={{ width: "15px", height: "15px" }} />}
                    iconPosition={"left"}
                  />
                </div>
              </div>
            </div>
          </div>
        </ClickAwayListener>
      </div>
    );
  };

  const allotmentCard = allCrmAllotments.map((allotment, index) => {
    return (
      <Grid
        className={classes.Grid}
        item
        xs={4}
        sm={4}
        md={4}
        lg={4}
        key={"allotmentCard" + index}
      >
        <Card className={cssClasses.eventWrap} key={allotment?.id}>
          <div className={cssClasses.cardHeader}>
            <div className={cssClasses.tokenNumWrap}>
              {!allotment?.inventory_merge_id && (
                <span>
                  {" "}
                  {allotment?.displaywingname
                    ? allotment?.displaywingname
                    : allotment?.wing_name}{" "}
                  - {allotment?.unit_no}{" "}
                </span>
              )}
              {allotment?.inventory_merge_id && (
                <span>
                  {" "}
                  {/* {allotment?.merged_wing_name} -{" "} */}
                  {allotment?.mergeddisplaywingname
                    ? allotment?.mergeddisplaywingname
                    : allotment?.merged_wing_name}{" "}
                  - {allotment?.merged_unit_no_one} {"-"}{" "}
                  {allotment?.merged_unit_no_two}{" "}
                </span>
              )}
              <span>|</span>
              {!allotment?.inventory_merge_id && (
                <span>{allotment?.project_name}</span>
              )}
              {allotment?.inventory_merge_id && (
                <span>{allotment?.merged_project_name}</span>
              )}
            </div>
            {allotment?.unitof && <div><LeadStatusChip
              label={allotment?.unitof}
              style={{
                color: "#3538CD",
                backgroundColor: "#EEF4FF",
              }}
            /></div>}
          </div>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              width: "100%",
            }}
          >
            <div className={cssClasses.chipWrapper}>
              {allotment.status === "Agreement Done" && (
                <LeadStatusChip
                  label={allotment.status}
                  icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
                  style={{ color: "#027A48", backgroundColor: "#ECFDF3" }}
                ></LeadStatusChip>
              )}
              {/* SDR Status */}
              <div className={cssClasses.tokenStatus}>
                {!allotment?.sdrcomplete && (
                  <LeadStatusChip
                    label={"SDR Pending"}
                    icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
                    style={{ color: "#B54708", backgroundColor: "#FFFAEB" }}
                  />
                )}
                {allotment?.sdrcomplete && (
                  <LeadStatusChip
                    label={"SDR Complete"}
                    icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
                    style={{ color: "#027A48", backgroundColor: "#ECFDF3" }}
                  />
                )}
              </div>
              {/* AV Status */}
              <div className={cssClasses.tokenStatus}>
                {!allotment?.is_changeable_value && (
                  <LeadStatusChip
                    label={"AV Not Changed"}
                    icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
                    style={{ color: "#027A48", backgroundColor: "#ECFDF3" }}
                  />
                )}
                {allotment?.is_changeable_value && (
                  <LeadStatusChip
                    label={"AV Changed"}
                    icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
                    style={{ color: "#B54708", backgroundColor: "#FFFAEB" }}
                  />
                )}
              </div>
              {/* Agreement KYC Status */}
              <div className={cssClasses.tokenStatus}>
                {!allotment?.is_agreement_form_filled && (
                  <LeadStatusChip
                    label={"Agreement KYC Pending"}
                    icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
                    style={{ color: "#B54708", backgroundColor: "#FFFAEB" }}
                  />
                )}
                {allotment?.is_agreement_form_filled && (
                  <LeadStatusChip
                    label={"Agreement KYC Done"}
                    icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
                    style={{ color: "#027A48", backgroundColor: "#ECFDF3" }}
                  />
                )}
              </div>
              {/* OCR Status */}
              <div className={cssClasses.tokenStatus}>
                {allotment?.isocrgreater === "less" ? (
                  <LeadStatusChip
                    label={"OCR < 10%"}
                    icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
                    style={{ color: "#B54708", backgroundColor: "#FFFAEB" }}
                  />
                ) : allotment?.isocrgreater === "equal" ? (
                  <LeadStatusChip
                    label={"OCR = 10%"}
                    icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
                    style={{ color: "#027A48", backgroundColor: "#ECFDF3" }}
                  />
                ) : (
                  <LeadStatusChip
                    label={"OCR > 10%"}
                    icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
                    style={{ color: "#027A48", backgroundColor: "#ECFDF3" }}
                  />
                )}
              </div>
              <div className={cssClasses.tokenStatus}>
                {allotment?.isemailsent && (
                  <LeadStatusChip
                    label={"Email Sent"}
                    icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
                    style={{ color: "#6941C6", backgroundColor: "#F4EBFF" }}
                  />
                )}
              </div>
               {/* Emandate Status */}
               <div className={cssClasses.tokenStatus}>
                                {["163", "165"].includes(
                                    String(allotment?.new_payment_plan?.Id),
                                    ) &&
                                    allotment?.isemandateeligible !== null &&
                                    allotment?.isemandateeligible !== false &&
                                    allotment?.crmemandatestatus !== null && (
                                    <>
                                    {/* ✅ Completed */}
                                    {allotment?.crmemandatestatus === "Completed" && (
                                        <LeadStatusChip
                                        label="Emandate Completed"
                                        icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
                                        style={{
                                            color: "#027A48",
                                            backgroundColor: "#ECFDF3",
                                        }}
                                        />
                                    )}

                                    {/*  Partial */}
                                    {allotment?.crmemandatestatus === "Partial" && (
                                        <LeadStatusChip
                                        label="Emandate Partially Completed"
                                        icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
                                        style={{
                                            color: "#6941C6",
                                            backgroundColor: "#F4EBFF",
                                        }}
                                        />
                                    )}

                                    {/*  Pending / Initiated */}
                                    {(allotment?.crmemandatestatus === "Pending") && (
                                        <LeadStatusChip
                                        label="Emandate Pending"
                                        icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
                                        style={{
                                            color: "#B54708",
                                            backgroundColor: "#FEF3F2",
                                        }}
                                        />
                                    )}
                                    </>
                  )}
            </div>
              
            </div>
            <div className={cssClasses.tokenActions}>
              <ThreeDotsMenu
                list={allotment?.menuOptions}
                selectedValue={(e) => {
                  if (e === "Check Virtual Account Status") {
                    setLeadDisplayId(allotment.leaddisplayid)
                    setVirtualAccountStatusModal(true)
                  }
                  if (e === "Send Test Mail") {
                    setSelectedAllotmentForSendTestMail(allotment);
                  }
                  if (e === "Send Email To Customer") {
                    // selectedAllotmentObject?.crmUserId?.crmUserDocUrl   == crm_user_doc_url
                    let _allotment = {
                      ...allotment,
                      crmUserId: {
                        crmUserDocUrl: allotment.crm_user_doc_url,
                      },
                    };
                    setSelectedAllotmentForSendToLead(_allotment);
                  }
                  if (e === "View Cost Sheet") {
                    let _allotment = {
                      ...allotment,
                      crmUserId: {
                        crmUserDocUrl: allotment.crm_user_doc_url,
                      },
                    };
                    setSelectedAllotmentForSendToLead(_allotment);
                    setViewCostSheet(true);
                  }
                  if (e === "View CRM Details") {
                    let _allotment = {
                      ...allotment,
                      allotmentPaymentId: {
                        paidAmt: allotment.paidamt,
                        unitCost: allotment.unitcost,
                        allotmentPaymentId: allotment.allotment_payment_id,
                        applicationApiRes: allotment?.application_api_res,
                        "100AmrRes": allotment?.amr_100_res,
                        "100B2bRes": allotment?.b2b_100_res,
                        GstAmrRes: allotment?.gst_amr_res,
                        gstB2bRes: allotment?.gst_b2b_res,
                        SdrB2bRes: allotment?.sdr_b2b_res,
                        WithoutTdsRes: allotment?.without_tds_res,
                      },
                    };
                    setSelectedAllotmentForViewCrmDetails(_allotment);
                  }
                  if (e === "Timeline And Notes") {
                    setAllotmentData(allotment)
                    setcrmTimeLineModalToggle(true);
                  }
                  if (e === "Preview Agreement Confirmation Form") {
                    SetPreviewAggrementModalToggle(true);
                    SetPreviewAggrementData(allotment);
                  }
                }}
              />
            </div>
          </div>
          <div
            className={cssClasses.leadDetailsDiv}
            style={{ flexDirection: "column" }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                width: "100%",
              }}
            >
              <div
                className={cssClasses.tokenNumWrap}
                style={{ alignItems: "baseline" }}
              >
                <p>{allotment?.lead_name}</p>
                <p
                  style={{
                    fontFamily: "Inter-Regular",
                    fontStyle: "normal",
                    fontWeight: 400,
                    fontSize: "1.4rem",
                    lineHeight: "1.8rem",
                    color: "#667085",
                  }}
                >
                  {"VJ" +
                    allotment?.leaddisplayid
                      ?.toString()
                      ?.replace(
                        allotment?.leaddisplayid?.toString()?.substring(8, 12),
                        "-" +
                        allotment?.leaddisplayid?.toString()?.substring(8, 12)
                      )}
                </p>
              </div>
              <div
                className={cssClasses.allotmentPaymentId}
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <p>+91 {allotment?.bookingformcontactnumber}</p>
                <a
                  href={`tel:+91${allotment?.bookingformcontactnumber}`}
                  data-action="share/whatsapp/share"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <CallIcon
                    style={{ width: "3rem", height: "3rem" }}
                    round={true}
                  />
                </a>
              </div>
            </div>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                width: "100%",
              }}
            >
              <p style={{ color: "darkgray", fontSize: "1.4rem" }}>
                {allotment?.allotment_payment_id}
              </p>
            </div>
            <div style={{
              display: "flex",
              gap: "1rem",
              justifyContent: "space-between",
              marginTop: "1rem",
              width: "100%",
              flexDirection: "row"
            }}>
              {/* <div
                style={{
                  display: "flex",
                  gap: "1rem",
                  justifyContent: "start",
                }}
              >
                {allotment?.leadvjop && <div><LeadStatusChip
                  label="VJOP"
                  style={{
                    color: "rgb(180, 35, 24)",
                    backgroundColor: "rgb(254, 243, 242)",
                  }}
                /></div>}
              </div> */}
               <div
                style={{
                  display: "flex",
                  gap: "1rem",
                  justifyContent: "start",
                }}
              >
                {/* {allotment?.leadvjop && <div><LeadStatusChip
                                label="VJOP"
                                style={{
                                  color: "rgb(180, 35, 24)",
                                  backgroundColor: "rgb(254, 243, 242)",
                                }}
                              /></div>} */}
                {allotment?.leadvjop ? (
                  allotment?.leadsubtype?.trim?.().toLowerCase?.() === "loyalty" ? (
                    <LeadStatusChip
                      label="VJOP-LOYALTY"
                      style={{
                        color: "rgb(180, 35, 24)",
                        backgroundColor: "rgb(254, 243, 242)",
                        fontSize: "0.85rem",
                        minWidth: "140px",
                        textAlign: "center",
                      }}
                    />
                  ) : (
                    <LeadStatusChip
                      label="VJOP"
                      style={{
                        color: "rgb(180, 35, 24)",
                        backgroundColor: "rgb(254, 243, 242)",
                        fontSize: "0.85rem",
                        minWidth: "140px",
                        textAlign: "center",
                      }}
                    />
                  )
                ) : (
                  allotment?.leadtype && (
                    <LeadStatusChip
                      label={allotment.leadtype}
                      style={{
                        color: "rgb(24, 90, 180)",
                        backgroundColor: "rgb(240, 247, 255)",
                        fontSize: "0.85rem",
                        minWidth: "140px",
                        textAlign: "center",
                      }}
                    />
                  )
                )}
              </div>

              <div
                style={{
                  display: "flex",
                  gap: "1rem",
                  justifyContent: "end",
                }}
              >
                {allotment?.isdiscountapplied ? (
                  <LeadStatusChip
                    label={"Discount Applied"}
                    style={{ color: "#234a2e", backgroundColor: "#b8e6c4" }}
                  ></LeadStatusChip>
                ) : (
                  allotment?.isdiscounteligible && (
                    <LeadStatusChip
                      label={"Discount Eligible"}
                      style={{
                        color: "#FF4F00",
                        backgroundColor: "#fad5be",
                      }}
                    ></LeadStatusChip>
                  )
                )}
              </div>
            </div>
          </div>
          <div
            className={cssClasses.tokenData}
            style={{ justifyContent: "flex-start" }}
          >
            <div className={cssClasses.tokenLastUpdate}>
              <p
                style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}
              >
                <CalendarTodayIcon />{" "}
                <span style={{ fontWeight: "600", color: "#475467" }}>
                  Agreement done on :
                </span>
              </p>
              <p style={{ fontWeight: "600", color: "#222429" }}>
                {/* {getAgreementDateInFormat(
                  allotment?.agreement_status?.agreement_date
                )} */}
                {allotment?.agreement_status?.agreement_date ?
                  allotment?.agreement_status?.agreement_date
                  : allotment?.old_allotment_agreement_data
                    ? getAgreementDateInFormat(allotment?.old_allotment_agreement_data)
                    : "-"}
              </p>
            </div>
          </div>
          <div className={cssClasses.cardDetails}>
            <div className={cssClasses.tokenDetails}>
              <div
                className={cssClasses.tokenData}
                style={{ justifyContent: "space-between" }}
              >
                <span>
                  {" "}
                  {allotment?.event_title
                    ? allotment?.event_title
                    : "Sustenance "}{" "}
                </span>
                {allotment?.event_title &&
                  allotment?.pricing_type === "preselect" && (
                    <span>
                      <LeadStatusChip
                        label={"Preselect"}
                        style={{
                          color: "#3538CD",
                          backgroundColor: "#EEF4FF",
                        }}
                      />
                    </span>
                  )}
                <div className={cssClasses.tokenLastUpdate}>
                  <ReactTimeAgo
                    style={{ fontSize: "1.2rem" }}
                    date={allotment?.last_updated_at ?? allotment?.created_at}
                    locale="en-US"
                  />
                </div>
              </div>
              <div
                className={cssClasses.tokenData}
                style={{ justifyContent: "space-between" }}
              >
                <div className={cssClasses.tokenLastUpdate} style={{ flex: 1 }}>
                  <p>VJ SM - {allotment?.sales_user_name}</p>
                  {/* <p>VJ SM - {allotment.cpbillingname}</p> */}
                  {/* { allotment?.allotmentPaymentId?.crmuserid && allotment?.allotmentPaymentId?.crmusername && <p>VJ CRM - {allotment?.allotmentPaymentId?.crmusername}</p>} */}
                  {allotment?.crm_user_name && allotment?.crm_user_name && (
                    <p>VJ CRM - {allotment?.crm_user_name}</p>
                  )}
                </div>
              </div>
              <div
                className={cssClasses.tokenData}
                style={{ justifyContent: "space-between" }}
              >
                <div>
                  {allotment?.display_inventory_type?.includes(
                    "Inventory Type"
                  ) && <span>{allotment?.inventory_type}</span>}
                  {allotment?.display_inventory_type?.includes(
                    "Display Unit Type"
                  ) && <span>{"(" + allotment?.display_unit_type + ")"}</span>}
                  {!allotment?.inventory_type && <span>Merged</span>}
                </div>
              </div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  width: "100%",
                }}
              >
                <div>
                  <span>Alloted By: </span>
                  <span>{allotment?.allotedbyuser}</span>
                </div>
                <div>
                  <span>Alloted On: </span>
                  <span>
                    {new Date(allotment?.preselectconfirmationdate ?? allotment?.created_at).toDateString()},{" "}
                    {new Date(allotment?.preselectconfirmationdate ?? allotment?.created_at).toLocaleTimeString([], {
                      hour: "2-digit",
                      minute: "2-digit",
                    })}
                  </span>
                </div>
              </div>
            </div>
          </div>
          {allotment?.paymentplantitle &&
            <div style={{
              display: "flex",
              gap: "1rem",
              width: "100%",
              fontSize: "1.4rem",
              color: "rgba(220, 104, 3, 1)",
            }}>
              <span style={{ textTransform: "capitalize" }}>Payment Plan {allotment?.paymentplantitle} is selected.</span>
            </div>}
        </Card>
      </Grid>
    );
  });

  const tagGridColumns = [
    {
      field: "action",
      headerName: "",
      // flex: 1,
      // width: showDropDown ? 200 : 160,
      width: 100,
      renderCell: (params) => {
        return (
          <div className={cssClasses.actionDiv}>
            <div>
              <Checkbox
                style={{ width: "2rem", height: "2rem", transform: "scale(2)" }}
                checked={
                  selectedAllotments.filter((val) => val?.id === params.id)
                    .length > 0
                    ? true
                    : false
                }
                onChange={(e) => {
                  const payload = [...selectedAllotments];
                  if (e.target.checked) {
                    payload.push(params?.row);
                    setSelectedAllotments(payload);
                    setSelectedAllotmentDataToApprove(payload);
                  } else {
                    const index = selectedAllotments.findIndex(
                      (val) => val?.id === params?.id
                    );
                    payload.splice(index, 1);
                    setSelectedAllotments(payload);
                    setSelectedAllotmentDataToApprove(payload);
                  }

                  if (payload?.length === allCrmAllotments?.length) {
                    setSelectBtnName("Remove All");
                  } else {
                    setSelectBtnName("Select All");
                  }
                }}
              />
              <ThreeDotsMenu
                // list={["Details", "Sync", "Check Status"]}
                // list={[
                //   "Send Test Mail",
                //   "Send Email To Customer",
                //   "View CRM Details",
                // ]}
                list={params.row?.menuOptions}
                selectedValue={(e) => {
                  if (e === "Check Virtual Account Status") {
                    setLeadDisplayId(params.row?.leaddisplayid)
                    setVirtualAccountStatusModal(true)
                  }
                  if (e === "Send Test Mail") {
                    setSelectedAllotmentForSendTestMail(params.row);
                  }
                  if (e === "Send Email To Customer") {
                    setSelectedAllotmentForSendToLead(params.row);
                    setSelectedAllotmentDataToApprove([params?.row]);
                  }
                  if (e == "View Cost Sheet") {
                    setSelectedAllotmentForSendToLead(params.row);
                    setSelectedAllotmentDataToApprove([params?.row]);
                    setViewCostSheet(true);
                  }
                  if (e === "View CRM Details") {
                    setSelectedAllotmentForViewCrmDetails(params.row);
                  }
                  if (e === "Timeline And Notes") {
                    setAllotmentData(params?.row);
                    setcrmTimeLineModalToggle(true);
                  }
                  if (e === "Check Virtual Account Status") {
                    setLeadDisplayId(params.row?.leaddisplayid)
                    setVirtualAccountStatusModal(true)
                  }
                }}
              />
            </div>
          </div>
        );
      },
    },
    {
      field: "unit",
      headerName: "Unit",
      width: 200,
      renderCell: (params) => {
        return (
          <div>
            <div>
              <div>
                {!params?.row?.inventory_merge_id && (
                  <span>
                    {" "}
                    {params?.row?.displaywingname
                      ? params?.row?.displaywingname
                      : params?.row?.wing_name}{" "}
                    - {params?.row?.unit_no}{" "}
                  </span>
                )}
                {params?.row?.inventory_merge_id && (
                  <span>
                    {" "}
                    {/* {params?.row?.merged_wing_name} -{" "} */}
                    {params?.row?.mergeddisplaywingname
                      ? params?.row?.mergeddisplaywingname
                      : params?.row?.merged_wing_name}{" "}
                    - {params?.row?.merged_unit_no_one} {"-"}{" "}
                    {params?.row?.merged_unit_no_two}{" "}
                  </span>
                )}
              </div>
              <div>
                {!params?.row?.inventory_merge_id && (
                  <span>{params?.row?.project_name}</span>
                )}
                {params?.row?.inventory_merge_id && (
                  <span>{params?.row?.merged_project_name}</span>
                )}
              </div>
            </div>
          </div>
        );
      },
    },
    {
      field: "allotmentId",
      headerName: "Allotment Id",
      width: 200,
      renderCell: (params) => {
        return (
          <Tooltip
            className={classes.Tooltip}
            placement="bottom-start"
            title={
              <div style={{ fontSize: "1.4rem" }}>
                <p>{params.row?.allotment_payment_id}</p>
              </div>
            }
          >
            <div style={{ whiteSpace: "normal", lineBreak: "anywhere" }}>
              {params.row?.allotment_payment_id}
            </div>
          </Tooltip>
        );
      },
    },
    {
      field: "leadsDetails",
      headerName: "Leads Name",
      width: 230,
      renderCell: (params) => {
        return (
          <Tooltip
            className={classes.Tooltip}
            placement="bottom-start"
            title={
              <div style={{ fontSize: "1.4rem" }}>
                <p style={{ whiteSpace: "break-spaces" }}>
                  {params.row?.lead_name}
                </p>
              </div>
            }
          >
            <div>
              <p style={{ whiteSpace: "break-spaces" }}>
                {params.row?.lead_name}
              </p>
            </div>
          </Tooltip>
        );
      },
    },
    {
      field: "status",
      headerName: "Email Status",
      flex: 1,
      minWidth: 200,
      renderCell: (params) => {
        return (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              width: "100%",
            }}
          >
            <div className={cssClasses.chipWrapper} style={{ gap: "0px" }}>
              <div className={cssClasses.tokenStatus}>
                {params?.row?.isemailsent ? (
                  <LeadStatusChip
                    label={"Email Sent"}
                    icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
                    style={{
                      color: "#6941C6",
                      backgroundColor: "#F4EBFF",
                    }}
                  />
                ) : (
                  <LeadStatusChip
                    label={"Email Not Sent"}
                    icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
                    style={{
                      color: "#6941C6",
                      backgroundColor: "#F4EBFF",
                    }}
                  />
                )}
              </div>
            </div>
          </div>
        );
      },
    },
    {
      field: "sdrStatus",
      headerName: "SDR Status",
      flex: 1,
      minWidth: 200,
      renderCell: (params) => {
        return (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              width: "100%",
            }}
          >
            <div className={cssClasses.chipWrapper} style={{ gap: "0px" }}>
              <div className={cssClasses.tokenStatus}>
                {!params?.row?.sdrcomplete ? (
                  <LeadStatusChip
                    label={"SDR Pending"}
                    icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
                    style={{
                      color: "#B54708",
                      backgroundColor: "#FFFAEB",
                    }}
                  />
                ) : (
                  <LeadStatusChip
                    label={"SDR Complete"}
                    icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
                    style={{
                      color: "rgb(2, 122, 72)",
                      backgroundColor: "rgb(236, 253, 243)",
                    }}
                  />
                )}
              </div>
            </div>
          </div>
        );
      },
    },
    {
      field: "event",
      headerName: "Event",
      width: 210,
      renderCell: (params) => {
        return (
          <Tooltip
            className={classes.Tooltip}
            placement="bottom-start"
            title={
              <div style={{ fontSize: "1.4rem" }}>
                <p>
                  {params.row.event_title
                    ? params.row.event_title
                    : "Sustenance"}
                </p>
              </div>
            }
          >
            <div
              style={{
                textOverflow: "ellipsis",
                overflow: "hidden",
                whiteSpace: "break-spaces",
              }}
            >
              {params.row.event_title ? params.row.event_title : "Sustenance"}
            </div>
          </Tooltip>
        );
      },
    },
    {
      field: "vjSm",
      headerName: "VJ SM",
      width: 160,
      renderCell: (params) => {
        return <div>{params.row.sales_user_name}</div>;
      },
    },
    {
      field: "vjCrm",
      headerName: "VJ CRM",
      width: 180,
      renderCell: (params) => {
        return <div>{params.row.crm_user_name}</div>;
      },
    },
    {
      field: "allotedOn",
      headerName: "Alloted On",
      width: 250,
      renderCell: (params) => {
        return (
          <Tooltip
            className={classes.Tooltip}
            placement="bottom-start"
            title={
              <div style={{ fontSize: "1.4rem" }}>
                <p>
                  {new Date(params?.row?.created_at).toDateString()},{" "}
                  {new Date(params?.row?.created_at).toLocaleTimeString([], {
                    hour: "2-digit",
                    minute: "2-digit",
                  })}
                </p>
              </div>
            }
          >
            <div>
              <span>
                {new Date(params?.row?.created_at).toDateString()},{" "}
                {new Date(params?.row?.created_at).toLocaleTimeString([], {
                  hour: "2-digit",
                  minute: "2-digit",
                })}
              </span>
            </div>
          </Tooltip>
        );
      },
    },
    {
      field: "lastUpdated",
      headerName: "Last Updated",
      width: 270,
      renderCell: (params) => {
        return (
          <Tooltip
            className={classes.Tooltip}
            placement="bottom-start"
            title={
              <div style={{ fontSize: "1.4rem" }}>
                <p>
                  {new Date(params?.row?.last_updated_at).toDateString()},{" "}
                  {new Date(params?.row?.last_updated_at).toLocaleTimeString(
                    [],
                    {
                      hour: "2-digit",
                      minute: "2-digit",
                    }
                  )}
                </p>
              </div>
            }
          >
            <div>
              <span>
                {new Date(params?.row?.last_updated_at).toDateString()},{" "}
                {new Date(params?.row?.last_updated_at).toLocaleTimeString([], {
                  hour: "2-digit",
                  minute: "2-digit",
                })}
              </span>
            </div>
          </Tooltip>
        );
      },
    },
  ];

  const handleAllSelect = () => {
    if (selectBtnName === "Select All") {
      setSelectBtnName("Remove All");
      setSelectedAllotmentDataToApprove(allCrmAllotments);
      setSelectedAllotments(allCrmAllotments);
    } else {
      setSelectBtnName("Select All");
      setSelectedAllotments([]);
    }
  };

  return (
    <>
      <div className={cssClasses.content}>
        <div
          className={cssClasses.actionWrapper}
          style={{ justifyContent: "space-between", alignItems: "center" }}
        >
          <div
            className={`${cssClasses.countWrapper} ${cssClasses.countWrapper1}`}
          >
            <div style={{ display: "flex", gap: "3rem", alignItems: "center" }}>
              <p>{totalCount} Completed</p>
              <p>{emailSentCount} Total Email Sent</p>
            </div>
          </div>
          <div
            className={cssClasses.searchWrapper}
            style={{ display: "flex", gap: "10px", alignItems: "center" }}
          >
            <div>{filterContent()}</div>
            <div className={cssClasses.filterSortWrapper}>
              <div className={cssClasses.label}>
                <p style={{ margin: "4px 0", fontSize: "1.6rem" }}>Sort by</p>
              </div>

              <div className={cssClasses.dropdownWrapper}>
                <DropDown
                  onChangeSelect={(e) => {
                    filterAllotmentBySort(e);
                  }}
                  selectedValue={filterBy}
                  style={{ selectedColor: "#175CD3", background: "#E8F0FE" }}
                  list={listsOrder}
                />
              </div>
            </div>
            {/* <ViewToggleSwitch setMode={setMode} /> */}
            {mode === "Table View" && (
              <Button
                style={{
                  color: "#fff",
                  backgroundColor: "#006AFF",
                  fontSize: "1.4rem",
                  lineHeight: "2rem",
                  fontFamily: "Inter-Medium !important",
                  width: "21rem",
                }}
                btnName={"Send Mail to Customer"}
                disable={selectedAllotments?.length === 0}
                clicked={() => {
                  setSelectedAllotmentForSendToLead(true);
                }}
              />
            )}
            <SearchBar
              placeholder={"Search by Lead Name Or Unit No"}
              xStyle={{
                "& input": {
                  fontSize: "1.3rem !important",
                  fontFamily: "Inter-Medium !important",
                },
              }}
              width="320px"
              search={debouncedFetchSearchData}
              id={"tagPendingCrmAllotmentLeadName"}
            />
          </div>
        </div>

        {allCrmAllotments.length > 0 ? (
          <>
            {mode === "Card View" && (
              <Box
                id="scrollableDiv"
                className={cssClasses.mainTabPanelWrapper}
              >
                <Box sx={{ flexGrow: 1 }}>
                  <InfiniteScroll
                    dataLength={allCrmAllotments.length}
                    next={() => {
                      if (hasMore.current) {
                        pageNumber.current = pageNumber.current + 1;
                        getCrmAllotmentsFromServer(true);
                      }
                    }}
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      overflowY: "auto",
                    }} //To put endMessage and loader to the top.
                    hasMore={hasMore}
                    // loader={<p className={cssClasses.infiniteScrollLoadingText}>Loading...</p>}
                    scrollableTarget="scrollableDiv"
                  >
                    <Grid
                      style={{
                        marginTop: "0rem",
                        marginBottom: "1rem",
                        marginLeft: "0rem",
                        width: "100%",
                      }}
                      container
                      spacing={{ xs: 2, md: 3, lg: 3 }}
                      columns={{ xs: 4, sm: 4, md: 8, lg: 8 }}
                    >
                      {allotmentCard}
                    </Grid>
                  </InfiniteScroll>
                </Box>
              </Box>
            )}
            {mode === "Table View" && (
              <div className={cssClasses.tableContainer}>
                <div
                  style={{
                    width: "100%",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <label style={{ fontSize: "1.6rem" }}>
                    {/* {selectedAllotments?.length} Tags Selected */}
                    {selectBtnName === "Remove All" ? totalCount : selectedAllotments?.length} Tags Selected
                  </label>
                  <Button
                    btnName={selectBtnName}
                    style={{
                      color: "#fff",
                      width: "150px",
                      backgroundColor: "#006AFF",
                      fontSize: "1.4rem",
                      lineHeight: "2rem",
                      fontFamily: "Inter-Medium !important",
                    }}
                    clicked={() => {
                      handleAllSelect();
                    }}
                  />
                </div>
                <ServerPaginationGrid
                  sx={{
                    "& .MuiDataGrid-columnHeaders + div": {
                      height: "calc(100vh - 400px) !important",
                    },
                  }}
                  name="crm-complete"
                  rows={allCrmAllotments}
                  columns={tagGridColumns}
                  depStr={depStr}
                  count={totalCount}
                  getDataByPage={getFilterAllotmentForDatagrid}
                />
              </div>
            )}
          </>
        ) : (
          <div style={{ height: "100%" }}>
            <p
              style={{
                position: "relative",
                top: "50%",
                transform: "translateY(-50%)",
                textAlign: "center",
                fontSize: "3rem",
              }}
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                }}
              >
                <img src={EmptyState} alt="No Data" />
                <span>No Allotment Available</span>
              </div>
            </p>
          </div>
        )}
      </div>

      {/* Change Price Modal */}
      {changePriceModalToggle && selectedCrmAllotmentForChangePrice && (
        <ChangePriceModal
          open={true}
          handleClose={(_result) => {
            if (typeof _result === "boolean" && _result === true) {
              getCrmAllotmentsFromServer(false);
            }
            setChangePriceModalToggle(false);
            setSelectedCrmAllotmentForChangePrice(null);
          }}
          crmAllotmentObject={selectedCrmAllotmentForChangePrice}
        />
      )}
      {selectedAllotmentForViewCrmDetails && (
        <ViewAllotedCrmDetailsModal
          selectedAllotmentObject={selectedAllotmentForViewCrmDetails}
          open={Boolean(selectedAllotmentForViewCrmDetails)}
          handleClose={(_result) => {
            setSelectedAllotmentForViewCrmDetails(null);
          }}
        />
      )}
      {/* Send mail to Customer */}
      {selectedAllotmentForSendToLead && (
        <ViewDocumentsModal
          selectedAllotmentObject={selectedAllotmentForSendToLead}
          open={Boolean(selectedAllotmentForSendToLead)}
          handleClose={(_result) => {
            setSelectedAllotments([]);
            setSelectedAllotmentForSendToLead(null);
            setViewCostSheet(false);
          }}
          sendMailToLead={() => {
            if (mode === "Table View") {
              selectedAllotmentDataToApprove.map((val, index) =>
                sendMailToLeadHandler(val)
              );
            } else {
              sendMailToLeadHandler();
            }
          }}
          isTableView={mode === "Table View" ? true : false}
          allotmentTableData={selectedAllotmentDataToApprove}
          isCompleteTab
          viewCostSheet={viewCostSheet}
        />
      )}
      {AlertModal}

      {/* Enter Email Modal */}
      {selectedAllotmentForSendTestMail && (
        <EnterEmailModal
          open={Boolean(selectedAllotmentForSendTestMail)}
          handleClose={(_result) => {
            if (_result?.flag) {
              sendTestMailHandler(_result?.email);
            } else {
              setSelectedAllotmentForSendTestMail(null);
            }
          }}
        />
      )}
      {crmTimeLineModalToggle && (
        <CrmTimeLineModal
          open={true}
          data={allotmentData}
          handleClose={closeCrmModal}
        />
      )}
      {virtualAccountStatusModal && (
        <UpdateLeadDetails open={virtualAccountStatusModal}
          handleClose={() => {
            setVirtualAccountStatusModal(false);
          }}
          leadDisplayId={leadDisplayId}
        />
      )}
      {previewAggrementModalToggle && (
        <PreviewAggrementConfirmationModal
          open={true}
          handleClose={() => SetPreviewAggrementModalToggle(false)}
          allotment={previewAggrementData}
          tabName={"Completed"}
        />
      )}
    </>
  );
}

export default CompletedCrm;

function numberWithCommas(x) {
  return x?.toString().replace(/\B(?=(?:(\d\d)+(\d)(?!\d))+(?!\d))/g, ",");
}